import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function AddProcessButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.addProcess")}</ActionButtonLayout>;

}

export default AddProcessButtonLayout;

